import React from 'react';

const OnlineDot = ({ status, size = 10 }) => (
  <span style={{
    width:size, height:size, borderRadius:'50%', display:'inline-block', flexShrink:0,
    background: status==='online' ? 'var(--green)' : 'var(--text3)',
    boxShadow:  status==='online' ? '0 0 6px var(--green)' : 'none',
  }} />
);

const AlarmBadge = ({ count }) => {
  if (!count) return <span style={{ fontSize:11, color:'var(--text3)' }}>—</span>;
  return (
    <span style={{ background:'var(--red-dim)', color:'var(--red)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:12, padding:'2px 8px', fontSize:11, fontWeight:700 }}>
      {count} alarm
    </span>
  );
};

export default function DeviceStatusTable({ devices = [], loading = false, showCustomer = false, onRegenerateKey }) {
  if (loading) return (
    <div style={{ textAlign:'center', padding:32, color:'var(--text3)' }}>
      <span className="spinner" style={{ marginRight:8 }} />Yükleniyor...
    </div>
  );
  if (!devices.length) return (
    <div style={{ textAlign:'center', padding:32, color:'var(--text3)' }}>Cihaz bulunamadı</div>
  );

  const fmt = n => Number(n || 0).toLocaleString('tr-TR');
  const fmtTime = d => d ? new Date(d).toLocaleString('tr-TR') : '—';
  const minutesAgo = d => {
    if (!d) return null;
    return Math.round((Date.now() - new Date(d).getTime()) / 60000);
  };

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Cihaz</th>
            {showCustomer && <th>Müşteri</th>}
            <th>Durum</th>
            <th>Bugün</th>
            <th>Son Heartbeat</th>
            <th>Son Veri</th>
            <th>Kamera</th>
            <th>Alarm</th>
            {onRegenerateKey && <th>İşlem</th>}
          </tr>
        </thead>
        <tbody>
          {devices.map(d => {
            const hbAgo = minutesAgo(d.last_heartbeat);
            const evAgo = minutesAgo(d.last_event_today || d.last_event_time);
            return (
              <tr key={d.id}>
                <td>
                  <div style={{ fontWeight:600 }}>{d.name}</div>
                  <div style={{ fontSize:10, color:'var(--text3)', fontFamily:'monospace', marginTop:2 }}>{d.device_key}</div>
                  {d.location && <div style={{ fontSize:10, color:'var(--text3)' }}>📍 {d.location}</div>}
                </td>
                {showCustomer && <td style={{ color:'var(--text2)', fontSize:13 }}>{d.customer_name}</td>}
                <td>
                  <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                    <OnlineDot status={d.status} />
                    <span style={{ fontSize:12, color: d.status==='online'?'var(--green)':'var(--text3)', fontWeight:600 }}>
                      {d.status==='online' ? 'Online' : 'Offline'}
                    </span>
                  </div>
                  {d.status==='offline' && d.last_seen && (
                    <div style={{ fontSize:10, color:'var(--red)', marginTop:2 }}>
                      {minutesAgo(d.last_seen)} dk önce
                    </div>
                  )}
                </td>
                <td>
                  <strong style={{ color:'var(--accent2)' }}>{fmt(d.today_in)}</strong>
                  <div style={{ fontSize:10, color:'var(--text3)' }}>giriş</div>
                </td>
                <td style={{ fontSize:12 }}>
                  <div>{fmtTime(d.last_heartbeat)}</div>
                  {hbAgo !== null && (
                    <div style={{ fontSize:10, color: hbAgo<2?'var(--green)':hbAgo<10?'var(--yellow)':'var(--red)' }}>
                      {hbAgo} dk önce
                    </div>
                  )}
                </td>
                <td style={{ fontSize:12 }}>
                  <div>{fmtTime(d.last_event_today || d.last_event_time)}</div>
                  {evAgo !== null && (
                    <div style={{ fontSize:10, color: evAgo<5?'var(--green)':evAgo<15?'var(--yellow)':'var(--red)' }}>
                      {evAgo} dk önce
                    </div>
                  )}
                </td>
                <td>
                  <span style={{ fontSize:11, color: d.camera_status==='ok'?'var(--green)': d.camera_status==='error'?'var(--red)':'var(--text3)' }}>
                    {d.camera_status || 'bilinmiyor'}
                  </span>
                </td>
                <td><AlarmBadge count={d.active_alarms} /></td>
                {onRegenerateKey && (
                  <td>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => onRegenerateKey(d)}
                      title="API Key Yenile"
                    >
                      🔑
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
